import { ModelType } from '@/modules/core/app/constants/ModelType';
import { BaseExtractedRecordModel } from '@/modules/ai/models/abstracts/BaseExtractedRecordModel';
import { ExtractedUserCollection } from '@/modules/ai/models/ExtractedUserCollection';
import { Document } from '@/modules/document/models/Document';
import { ContactAlias } from '@/modules/contact/models/ContactAlias';
import { Address } from '@/modules/address/models/Address';

export class ExtractedContact extends BaseExtractedRecordModel {
  id?: number;
  documentId?: number;
  contactId?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  birthSurname?: string;
  personTitle?: string;
  isEntity?: boolean;
  isCreatedManually?: boolean;
  email?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  gender?: string;
  document?: Relationship<Document | null>;
  extractedUsers!: Relationship<ExtractedUserCollection>;
  contactAliases?: Relationship<ContactAlias[]> | null;
  address?: Relationship<Address | null>;

  constructor(model: Partial<ExtractedContact> = {}) {
    super(model);

    this.id = model.id;
    this.documentId = model.documentId;
    this.contactId = model.contactId;
    this.firstName = model.firstName;
    this.middleName = model.middleName;
    this.lastName = model.lastName;
    this.birthSurname = model.birthSurname;
    this.personTitle = model.personTitle;
    this.isEntity = model.isEntity;
    this.isCreatedManually = model.isCreatedManually;
    this.email = model.email;
    this.phoneNumber = model.phoneNumber ?? '';
    this.dateOfBirth = model.dateOfBirth;
    this.gender = model.gender;
    this.document = Document.mapModelOrNull(model.document);
    this.extractedUsers = ExtractedUserCollection.mapModel(model.extractedUsers);
    this.contactAliases = ContactAlias.mapModelsOrNull(model.contactAliases);
    this.address = Address.mapModel(model.address);
  }

  getModelName(): ModelType {
    return ModelType.EXTRACTED_CONTACT;
  }

  get showAmountColumn(): boolean {
    return false;
  }

  get hasMatch(): boolean {
    return !!this.contactId;
  }

  get name(): string {
    return [this.firstName, this.middleName, this.lastName]
      .filter((name: string | undefined) => !!name)
      .join(' ');
  }

  get firstLetters(): string {
    const first: string = this.firstName?.charAt(0) ?? '';
    const last: string = this.lastName?.charAt(0) ?? this.middleName?.charAt(0) ?? '';

    return `${first}${last}`.toUpperCase();
  }

  get hasName(): boolean {
    return !!this.firstName || !!this.middleName || !!this.lastName;
  }

  get hasContactAliases(): boolean {
    return !!this.contactAliases?.length;
  }

  get nameFormatted(): string {
    return this.hasName ? this.name : '-';
  }
}
